import { Button } from '@sequencehq/core-components'

import { ManualTaskLayout } from 'Automations/components'
import { useManualTaskProcessorToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskProcessorToolkit'
import { QuotePreview } from './QuotePreview'
import { ModalQuoteApprovalResponse } from './QuoteApprovalResponse.modal'
import { QuoteReviewHeader } from '../QuoteReviewHeader'
import { TaskInput } from '../../types'
import { QuoteReviewDetails } from './QuoteReviewDetails'

export const QuoteReviewContent = ({ taskId }: { taskId: string }) => {
  const { manualTask, isPending, handleClose, completeTask } =
    useManualTaskProcessorToolkit<TaskInput>({
      taskId
    })

  if (isPending) {
    return <ManualTaskLayout.Loading />
  }

  if (!manualTask?.input) {
    return <ManualTaskLayout.Error />
  }

  const actions = (
    <ManualTaskLayout.Actions>
      <ModalQuoteApprovalResponse
        trigger={
          <Button
            variant="secondary"
            data-testid="watchtower.quoteApproval.reject"
          >
            Reject
          </Button>
        }
        outcome="REJECTED"
        completeTask={completeTask}
        quoteNumber={manualTask.input.quote.quoteNumber}
        quoteId={manualTask.input.quote.id}
      />
      <ModalQuoteApprovalResponse
        trigger={
          <Button
            variant="primary"
            data-testid="watchtower.quoteApproval.approve"
          >
            Approve
          </Button>
        }
        outcome="APPROVED"
        completeTask={completeTask}
        quoteNumber={manualTask.input.quote.quoteNumber}
        quoteId={manualTask.input.quote.id}
      />
    </ManualTaskLayout.Actions>
  )

  return (
    <ManualTaskLayout
      actions={actions}
      header={
        <ManualTaskLayout.Header
          taskId={taskId}
          title={
            <QuoteReviewHeader
              customer={manualTask.input.customer}
              quoteNumber={manualTask.input.quote.quoteNumber}
              quoteTitle={manualTask.input.quote.title}
            />
          }
          onClose={handleClose}
        />
      }
      content={
        <ManualTaskLayout.Content
          subject={
            <QuotePreview
              quote={manualTask.input.quote}
              customer={manualTask.input.customer}
              requestor={manualTask.input.requestor}
              createdAt={manualTask.createdAt}
            />
          }
          review={<QuoteReviewDetails taskInput={manualTask.input} />}
        />
      }
    />
  )
}
